import {
  ActionSheetController,
  LoadingController,
  ModalController,
  NavController,
  NavParams,
  Platform,
  ToastController
} from '@ionic/angular';
import { Keyboard } from '@awesome-cordova-plugins/keyboard/ngx';
import { Component, Renderer2 } from '@angular/core';
import { adjustViewZIndex } from '../../../globals';
import { EventObserver } from 'src/providers/event-service';
import {
  createPlayerList,
  FriendRequest,
  FriendRequestList,
  PlayerHomeInfo,
  PlayerInfo,
  PlayerList
} from '../../../data/player-data';
import {
  AbstractNotificationHandlerPage,
  NotificationHandlerInfo
} from '../../../providers/pushnotification-service/notification-handler-constructs';
import { FriendService } from '../../../providers/friend-service/friend-service';
import { ProfilePage } from '../profile/profile.page';
import { SearchPlayerListPage } from '../search-player-list/search-player-list';
import { NewContactPage } from '../new-contact/new-contact.page';
import { Observable, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { Location } from '@angular/common';
import { CancelRequestComponent } from '../New Game/friend-list/cancel-request/cancel-request.component';
import { RejectRequestComponent } from '../New Game/friend-list/reject-request/reject-request.component';
import { ServerResult } from 'src/data/server-result';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { PlayerService } from 'src/providers/player-service/player-service';
import { JsonService } from 'src/json-util';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
@Component({
  templateUrl: 'friend-list.page.html',
  selector: 'friend-list-page',
  styleUrls: ['friend-list.page.scss'],
})
export class FriendListPage {
  public friends: string = "friend";
  public friendType: string = "friend";
  public friendScreenName: string = "Friends";


  public requestByPlayer: boolean;
  public searchPlayer: string = '';
  public searchFriend: string = '';
  public refreshAttempted: boolean = false;
  public refreshPlayer: boolean = false;

  public sentExist: boolean = false;
  public receiveExist: boolean = false;

  public playerList: PlayerList;
  public requestFriends: FriendRequestList;
  public listFriends: PlayerList;
  public receivedList: Array<FriendRequest> = new Array<FriendRequest>();
  public sentList: Array<FriendRequest> = new Array<FriendRequest>();
  public friendRequests: Array<FriendRequest> = new Array<FriendRequest>();
  public playerRequests: Array<FriendRequest> = new Array<FriendRequest>();

  public refreshOnEnter: boolean = false;

  constructor(private nav: NavController,
    private Location: Location,
    private router: Router,
    private globalEventObserver: EventObserver,
    private platform: Platform,
    private keyboard: Keyboard,
    private friendService: FriendService,
    private toastCtl: ToastController,
    // private events: Events,
    private navParams: NavParams,
    private loadingCtrl: LoadingController,
    private actionSheetCtrl: ActionSheetController,
    private modalCtl: ModalController,
    private renderer: Renderer2,
    private playerService: PlayerService,
    private mg2uUtils: mygolfUtils,
    private flightService: ClubFlightService
    ) {

    this.requestFriends = {
      totalPages: 0,
      currentPage: 0,
      totalItems: 0,
      totalInPage: 0,
      success: true,
      friendRequests: new Array<FriendRequest>()
    };
    this.listFriends = {
      totalPages: 0,
      currentPage: 0,
      totalItems: 0,
      totalInPage: 0,
      success: true,
      players: new Array<PlayerInfo>()
    };

    this.globalEventObserver.getObservable().subscribe((data) => {
      if (data.chanel == "FriendListUpdate") {
        this._refreshValues(null, null);
      }
      if (data.chanel == "FriendRequestUpdate") {
        this.friends = "request";
        this._refreshValues(null, null);
      }
    })
    this.playerList = createPlayerList();
  }

  ngOnInit() {
    this._refreshValues(null, null);
  }

  ionViewDidEnter() {
    if (this.refreshOnEnter)
      this._refreshValues(null, null);
    this.refreshOnEnter = false;
  }

  ionViewWillEnter() {
    adjustViewZIndex(this.nav, this.renderer);
  }

  public refreshOnViewEntered(refresh: boolean) {
    this.refreshOnEnter = refresh;
  }

  public refreshPage(pushData: any) {
    this._refreshValues(null, null);
  }

  public getNotifications(): Array<NotificationHandlerInfo> {
    let notifications = new Array<NotificationHandlerInfo>();
    notifications.push({
      type: AbstractNotificationHandlerPage.TYPE_FRIEND_REQUEST,
      whenActive: "showToast",
      whenInactive: "none",
      needRefresh: true
    });
    notifications.push({
      type: AbstractNotificationHandlerPage.TYPE_FRIEND_REQUEST_ACCEPTED,
      whenActive: "showToast",
      whenInactive: "none",
      needRefresh: true
    });
    return notifications;
  }

  onSearchInput(searchbar) {
    this._refreshValues(null, null);
  }

  onSearchCancel() {

  }

  onPlayerInput(searchbar) {
    this.playerList = createPlayerList();
    this._refreshPlayer(null, null);
  }

  onRefresh(refresher) {
    this._refreshValues(refresher, null)
  }

  // openNewContact() {
  //     this.nav.push(NewContactPage);
  // }

  async openNewContact() {
    let newContact = await this.modalCtl.create({
      component: NewContactPage,
      componentProps: {
        //openedModal: true,
        openedAsDialog: true
      }

    });
    newContact.onDidDismiss().then((apply: any) => {
      // if (apply) {

      this._refreshFriends(null, null);
      // }
    });
    newContact.present();
  }

  searchNewContact() {
    this.router.navigate(['search-player-list'])
    // this.nav.push(SearchPlayerListPage);
  }

  async friendSelected(event, item: PlayerInfo) {
    let modal = await this.modalCtl.create({
      component: ProfilePage,
      componentProps: {
        status: 'friend',
        type: 'friendProfile',
        player: of(item),
        // Observable.of(item),
        openedModal: true
      }
    });
    modal.onDidDismiss().then((data: any) => {
      adjustViewZIndex(this.nav, this.renderer);
      if (data && data.data) {
        let datas = data.data


        if (datas.type == "requestFriend") {
          this.friends = "request";
          this._refreshValues(null, null);
        }
        if (datas.type == "acceptFriend")
          this._refreshValues(null, null);

        if (datas.type == "deleteFriend") {
          this._refreshValues(null, null);
        }
        if (datas.type == "deleteRequest") {
          this._refreshValues(null, null);
        }
      }


    });
    modal.present();
    // this.events.publish("friendSelected", item);
    // this.nav.push(ProfilePage, {
    //     status: 'friend',
    //     type: 'friendProfile',
    //     player: item,
    //     homeInfo: this.homeInfo
    // });
  }

  async requestSelected(event, item: FriendRequest) {
    // this.events.publish("requestSelected", item);
    let modal = await this.modalCtl.create({
      component: ProfilePage,
      componentProps: {
        requestByPlayer: item.requestByPlayer,
        status: 'pendingFriend',
        type: 'friendProfile',
        player: of(item.player),
        // Observable.of(item.player),
        openedModal: true
      }
    });
    modal.onDidDismiss().then((data: any) => {

      if (data && data.data) {
        var datas = data.data
        //

        if (datas.type == "requestFriend") {
          this.friends = "request";
          this._refreshValues(null, null);
        }
        if (datas.type == "acceptFriend") {
          this.friends = "friend";
          this._refreshValues(null, null);
        }
        if (datas.type == "deleteFriend") {
          this._refreshValues(null, null);
        }
        if (datas.type == "deleteRequest") {
          this._refreshValues(null, null);
        }
      }


    });
    modal.present();

    // this.nav.push(ProfilePage, {
    //     requestByPlayer: item.requestByPlayer,
    //     status: 'pendingFriend',
    //     type: 'friendProfile',
    //     player: item.player,
    //     homeInfo: this.homeInfo
    // });
  }

  doInfinite(infinite) {

    if (this.isMore()) {
      this._refreshValues(null, infinite);
      // if(this.friends === 'friend'){

      // } else {
      //   this._refreshPlayer(null, infinite);
      // }
    }
    else {

      infinite.target.complete();
      // infinite.complete();
      // infinite.enable(false);
    }

  }

  public isMore() {
    console.debug("is more ? ", this.playerList.totalPages, this.playerList.currentPage)
    if(this.friends === 'friend') {
      return this.listFriends.totalPages > 0 && this.listFriends.currentPage < this.listFriends.totalPages;

    } else return this.playerTotalPages > 0 && this.playerCurrentPage < this.playerTotalPages;
    //  this.playerList.totalPages > 0 && this.playerList.currentPage < this.playerList.totalPages;
  }

  receivedRequest() {
    this.receivedList = this.requestFriends.friendRequests.filter((req: FriendRequest) => {
      return !req.requestByPlayer;
    })
    this.receivedList = this.receivedList
      // .map((req: FriendRequest)=>{
      //     return req.player.firstName
      // })
      .sort((a, b) => {
        if (a.player.firstName < b.player.firstName) return -1
        else if (a.player.firstName > b.player.firstName) return 1;
        else return 0;
      });

  }

  sentRequest() {
    this.sentList = this.requestFriends.friendRequests.filter((req: FriendRequest) => {
      return req.requestByPlayer
    });
    this.sentList = this.sentList
      .sort((a, b) => {
        if (a.player.firstName < b.player.firstName) return -1
        else if (a.player.firstName > b.player.firstName) return 1;
        else return 0;
      });

  }

  private _refreshValues(refresher, infinite) {


    if (this.friends == "friend") {
      this._refreshFriends(refresher, infinite);
    }

    if (this.friends == "request") {
      this._refreshRequest(refresher, infinite);
    }

    if (this.friends == "find") {
      if(!infinite)
        this.playerList = createPlayerList();
      this._refreshPlayer(refresher, infinite);
    }
  }

  private async _refreshRequest(refresher, infinite) {

    this.refreshAttempted = false;

    let loader = await this.loadingCtrl.create({
      showBackdrop: false
    });

    let _pageSize = 99;
    let _params = {};
    _params["pageSize"] = _pageSize;

    loader.present().then(() => {
      this.refreshAttempted = false;
      this.friendService.searchFriendRequests(_params)
        .subscribe((friendRequests: FriendRequestList) => {
          loader.dismiss(friendRequests).then(() => {

            this.refreshAttempted = true;

            if (friendRequests) {
              this.requestFriends = friendRequests;
              this.receivedRequest();
              this.sentRequest();
            }

            if (this.sentList.length > 0) {
              this.sentExist = true;
            }

            if (this.receivedList.length > 0) {
              this.receiveExist = true;
            }

            if (this.platform.is("ios") && this.platform.is("capacitor")) {
              this.keyboard.hide();
            }

          });
        }, (error) => {
          loader.dismiss();
        }, () => {
          if (refresher) {
            refresher.complete();
          }
          if (infinite) {
            infinite.complete();
          }
        });

    });
  }

  private async _refreshFriends(refresher, infinite) {
    let loader = await this.loadingCtrl.create({
      showBackdrop: false
    });

    if(!infinite) this.listFriends = {
      totalPages: 0,
      currentPage: 0,
      totalItems: 0,
      totalInPage: 0,
      success: true,
      players: new Array<PlayerInfo>()
    }

    loader.present().then(() => {
      this.refreshAttempted = false;
      this.friendService.searchFriends(this.searchFriend, null, this.listFriends.currentPage + 1)
        .subscribe((friendRequests: PlayerList) => {
          loader.dismiss(friendRequests).then(() => {

            this.refreshAttempted = true;

            if (friendRequests.totalPages > 0)
              this.listFriends.currentPage++;
            if (friendRequests) {
              // this.listFriends = friendRequests;
              this.listFriends.currentPage = friendRequests.currentPage;
              this.listFriends.totalPages = friendRequests.totalPages;
              this.listFriends.totalItems = friendRequests.totalItems;
              this.listFriends.players.push(...friendRequests.players);
              this.listFriends.players.forEach((p: PlayerInfo) => {
                if (p?.addressInfo) {
                  p.countryId = p.addressInfo.countryId
                  p.countryName = p.addressInfo.countryName
                }
              })
            }

          });
        }, (error) => {
          loader.dismiss();
        }, () => {
          if (refresher) {
            refresher.target.complete();
          }
          if (infinite) {
            infinite.target.complete();
          }
        });

    });
  }

  playerCurrentPage: number = 0;
  playerTotalPages: number = 0;
  private async _refreshPlayer(refresher, infinite) {

    // if(this.subSearchFriends) return;
    this.refreshPlayer = false;

    if (!this.searchPlayer || this.searchPlayer == "") {
      this.refreshPlayer = false;
      return false;
    }

    let loader = await this.loadingCtrl.create({
      showBackdrop: false
    });
    if(!infinite) {
      this.playerList = createPlayerList();
      this.playerCurrentPage = 0;
      this.playerTotalPages = 0;
    }

    let _search = this.searchPlayer;
    let _letters = /[0-9]/;

    if (_search.match(_letters) && !infinite) {
      this.flightService
        .getPlayerById(Number(_search))
        .subscribe((response: any) => {
          let _data;
          if (response || (response.status && response.status === 200)) {
            _data = response;
            _data.playerId = _data.id;
            JsonService.deriveFullUrl(_data, 'profile');
            JsonService.deriveFullUrl(_data, 'image');
            // if (this.playersToExclude.length > 0) {
            //   let _found = this.playersToExclude.find((pe) => {
            //     if (pe && pe.player && pe.player.id === _data.id)
            //       return false;
            //     else return true
            //     // else this.players.unshift(_data);
            //   });
            //   if(_found) this.playerList.players.unshift(_data);
            // } else
            this.playerList.players.unshift(_data);
          }
        },(error)=>{
        },()=>{
        });
    }

    loader.present().then(() => {

      this.searchFriends(this.searchPlayer)
      .then((result: any)=>{

        this.playerService.searchPlayers(this.searchPlayer, true, this.playerCurrentPage + 1)
        // this.friendService.searchNonFriends(this.searchPlayer, this.playerCurrentPage + 1)
          .subscribe((playerList: PlayerList) => {
            loader.dismiss().then(() => {

              if (playerList.totalPages > 0)
                this.playerList.currentPage++;

              this.refreshPlayer = true;

              if (playerList) {
                this.playerCurrentPage = playerList.currentPage;
                this.playerTotalPages = playerList.totalPages;
                // this.playerList.currentPage = playerList.currentPage;
                // this.playerList.totalPages = playerList.totalPages;
                this.playerList.totalItems = playerList.totalItems;
                this.playerList.players.push(...playerList.players);
                this.playerList.players.forEach((p: PlayerInfo) => {
                  if (p?.addressInfo) {
                    p.countryId = p.addressInfo.countryId
                    p.countryName = p.addressInfo.countryName
                  }
                })

                let _receivedList = JsonService.clone(this.receivedList);
                _receivedList.forEach((r: FriendRequest)=>{
                  r.playerId = r.player.playerId
                })
                let _sentList = JsonService.clone(this.sentList);
                _sentList.forEach((r: FriendRequest)=>{
                  r.playerId = r.player.playerId
                })
                let _existingList = [..._receivedList, ..._sentList, ...this.listFriends.players];
                _existingList = this.mg2uUtils.getUnique(_existingList, 'playerId');
                console.debug("_existingList", _existingList);
                // const filteredArray = mergedArray.filter(item =>
                //   !objectD.some(d => d.id === item.id)
                // );
                // this.playerList.players = this.playerList.players.filter((p) => {
                //   !_existingList.some((eL)=>{
                //     eL.playerId === p.playerId
                //   })
                //   // this.receivedList // .player
                //   // this.sentList // .player
                //   // this.listFriends.players
                // });

                if(this.listFriends && this.listFriends.totalItems > 0) {
                  this.playerList.players = this.playerList.players.filter((p: PlayerInfo)=>{
                      let _nonFriend: boolean = true
                      this.listFriends.players.forEach((friend: PlayerInfo)=>{
                          if(p.playerId === friend.playerId)
                              _nonFriend = false;
                      })
                      return _nonFriend;
                  })
              }
              }
              if (this.platform.is("ios") && this.platform.is("capacitor")) {
                this.keyboard.hide();
              }

            });
          }, (error) => {
            loader.dismiss();
          }, () => {
            if (refresher) {
              refresher.target.complete();
            }
            if (infinite) {
              infinite.target.complete();
            }
          });
      }).catch((error)=>{

      this.playerService.searchPlayers(this.searchPlayer, true, this.playerCurrentPage + 1)
      // this.friendService.searchNonFriends(this.searchPlayer, this.playerCurrentPage + 1)
        .subscribe((playerList: PlayerList) => {
          loader.dismiss().then(() => {

            if (playerList.totalPages > 0)
              this.playerList.currentPage++;

            this.refreshPlayer = true;

            if (playerList) {
              this.playerCurrentPage = playerList.currentPage;
              this.playerTotalPages = playerList.totalPages;
              // this.playerList.currentPage = playerList.currentPage;
              // this.playerList.totalPages = playerList.totalPages;
              this.playerList.totalItems = playerList.totalItems;
              this.playerList.players.push(...playerList.players);
              this.playerList.players.forEach((p: PlayerInfo) => {
                if (p?.addressInfo) {
                  p.countryId = p.addressInfo.countryId
                  p.countryName = p.addressInfo.countryName
                }
              })

              let _receivedList = JsonService.clone(this.receivedList);
              _receivedList.forEach((r: FriendRequest)=>{
                r.playerId = r.player.playerId
              })
              let _sentList = JsonService.clone(this.sentList);
              _sentList.forEach((r: FriendRequest)=>{
                r.playerId = r.player.playerId
              })
              let _existingList = [..._receivedList, ..._sentList, ...this.listFriends.players];
              _existingList = this.mg2uUtils.getUnique(_existingList, 'playerId');
              console.debug("_existingList", _existingList);
              // const filteredArray = mergedArray.filter(item =>
              //   !objectD.some(d => d.id === item.id)
              // );
              // this.playerList.players = this.playerList.players.filter((p) => {
              //   !_existingList.some((eL)=>{
              //     eL.playerId === p.playerId
              //   })
              //   // this.receivedList // .player
              //   // this.sentList // .player
              //   // this.listFriends.players
              // });

              if(this.listFriends && this.listFriends.totalItems > 0) {
                this.playerList.players = this.playerList.players.filter((p: PlayerInfo)=>{
                    let _nonFriend: boolean = true
                    this.listFriends.players.forEach((friend: PlayerInfo)=>{
                        if(p.playerId === friend.playerId)
                            _nonFriend = false;
                    })
                    return _nonFriend;
                })
            }
            }
            if (this.platform.is("ios") && this.platform.is("capacitor")) {
              this.keyboard.hide();
            }

          });
        }, (error) => {
          loader.dismiss();
        }, () => {
          if (refresher) {
            refresher.target.complete();
          }
          if (infinite) {
            infinite.target.complete();
          }
        });
      })

    });

  }

  async playerSelected(event, item: PlayerInfo) {
    let modal = await this.modalCtl.create({
      component: ProfilePage,
      componentProps: {
        status: 'notFriend',
        type: 'friendProfile',
        player: of(item),
        // Observable.of(item),
        // homeInfo: this.homeInfo,
        openedModal: true
      }
    });
    modal.onDidDismiss().then((data: any) => {
      adjustViewZIndex(this.nav, this.renderer);
      if (data && data.data) {
        var datas = data.data
        //

        if (datas.type == "requestFriend") {
          this.friends = "request";
          this._refreshValues(null, null);
        }
        if (datas.type == "acceptFriend") {
          this.friends = "friend";
          this._refreshValues(null, null);
        }
        if (datas.type == "deleteFriend") {
          this._refreshValues(null, null);
        }
        if (datas.type == "deleteRequest") {
          this._refreshValues(null, null);
        }
      }



    });
    modal.present();
    // this.events.publish("playerSelected", item);
    // this.nav.push(ProfilePage, {
    //     status: 'notFriend',
    //     type: 'friendProfile',
    //     player: item,
    //     homeInfo: this.homeInfo
  }

  setFriendType(type: number) {
    console.log('type: ', type);
    if (type === 1) {
      this.friendType = 'friend';
      this.friends = 'friend';
      this.friendScreenName = 'Friends';
      this._refreshFriends(null, null);
      if (this.platform.is("ios") && this.platform.is("capacitor")) {
        this.keyboard.hide();
      }
    }
    if (type === 2) {
      this.friendType = 'request';
      this.friends = 'request';
      this.friendScreenName = 'Requests';
      this._refreshRequest(null, null);
      if (this.platform.is("ios") && this.platform.is("capacitor")) {
        this.keyboard.hide();
      }
    }
    if (type === 3) {
      this.friendType = 'find';
      this.friends = 'find';
      this.friendScreenName = 'Find | Add';
      this.playerList = createPlayerList();
      this._refreshPlayer(null, null);
      if (this.platform.is("ios") && this.platform.is("capacitor")) {
        this.keyboard.hide();
      }
    }

  }

  onBackpage() {
    this.Location.back();
  }

  async openCancelModal(){
    const modal = await this.modalCtl.create({
      component: CancelRequestComponent,
      mode: 'ios',
      cssClass: 'self-adjustable-modal'
    });

    await modal.present();
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
  }

  async openRejectModal(){
    const modal = await this.modalCtl.create({
      component: RejectRequestComponent,
      mode: 'ios',
      cssClass: 'self-adjustable-modal'
    });

    await modal.present();
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
  }

  async deleteRequestConfirm(player: any) {
    console.log('player: ', player);
    const modal = await this.modalCtl.create({
      component: RejectRequestComponent,
      mode: 'ios',
      cssClass: 'self-adjustable-modal',
      componentProps:{
        headerMessage : 'Delete Request',
        message : 'Are you sure you want Remove this Friend Request?'
      }
    });

    await modal.present();
    await modal.present().then((data:any) => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });

    modal.onDidDismiss().then((data:any)=>{
      if(data.data.isConfirm){
        this.deleteRequest(player?.playerId);
      }
    })
  }

  async deleteRequest(playerId) {
      // const playerData = JSON.parse(localStorage.getItem("mygolf2uapp.sessionInfo"));
      const busy = await this.loadingCtrl.create({
        message: 'Please wait...',
        duration: 5000,
      });
      busy.present().then(() => {
        this.friendService.cancelFriendRequest(playerId)
          .subscribe((result: ServerResult) => {
            if (busy) {
              busy.dismiss().then(() => {
                if (result.success) {
                  this.modalCtl.dismiss({ type: 'deleteRequest' });
                }
              });
            }
          }, (error) => {
            if (busy) {
              busy.dismiss().then(() => {
                this.modalCtl.dismiss();
                let msg = MessageDisplayUtil.getErrorMessage(error, 'Error deleting request');
                MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl, 3000, 'bottom');
              });
            }
          });
      });
  }

  acceptFriend(player) {
    this.friendService.acceptFriendRequest(player?.playerId)
      .subscribe((result: ServerResult) => {
        if (result.success) {
          // this.playerHomeActions.refreshForcefully();
          // this.viewCtrl.dismiss({type: "acceptFriend"});
          this.modalCtl.dismiss({ type: 'acceptFriend' });
        }
      }, (error) => {
        this.modalCtl.dismiss({ type: 'acceptFriend' });
        // this.viewCtrl.dismiss({type: "acceptFriend"});
        // globals.displayError(this.alertCtl, error, 'Accept Friend', 'OK');
      });
  }

  requestStore:string='received'
  requestReceived(data:string){
    if(data==='received'){
      this.requestStore = data
    }
    else if(data==='sent'){
      this.requestStore = data
    }
    else{
      return
    }
  }

  getPlayerImage(player) {
    if(player?.thumbnail) return player.thumbnail;
    else if(player?.photoUrl) return player.photoUrl;
    else if(player?.profile) return player.profile;
    else if(player?.image) return player.image;
  }

  subSearchFriends: Subscription;
  searchFriends(searchString: string) {
    return new Promise((resolve, reject)=>{

      // this.subSearchFriends =
      this.friendService.searchFriends(searchString, null, 1)
        .subscribe((friendRequests: PlayerList) => {

            this.refreshAttempted = true;

            if (friendRequests.totalPages > 0)
              this.listFriends.currentPage++;
            if (friendRequests) {
              // this.listFriends = friendRequests;
              this.listFriends.currentPage = friendRequests.currentPage;
              this.listFriends.totalPages = friendRequests.totalPages;
              this.listFriends.totalItems = friendRequests.totalItems;
              this.listFriends.players.push(...friendRequests.players);
              this.listFriends.players.forEach((p: PlayerInfo) => {
                if (p?.addressInfo) {
                  p.countryId = p.addressInfo.countryId
                  p.countryName = p.addressInfo.countryName
                }
              })
            }
        }, (error) => {

          // if(this.subSearchFriends) {
          //   this.subSearchFriends = null;
          //   this.subSearchFriends.unsubscribe();
          // }
          resolve(true)
        }, () => {
          // if(this.subSearchFriends) {
          //   this.subSearchFriends = null;
          //   this.subSearchFriends.unsubscribe();
          // }
          resolve(true)
        });
    })
  }

}
